import { BaseApiService } from "@mirage/services/BaseApiService";
import { PrePublicPortalWlConstants } from "@shared/prePublicPortalWestLindsay/constants";
import { WlPriceListJson } from "@shared/prePublicPortalWestLindsay/utils/PrePpWlFormFeeCalculator";

export default class PrePublicPortalWlSettingsService extends BaseApiService {
    constructor() {
        super(`${PrePublicPortalWlConstants.AppName}/settings`);
    }

    async getPriceList(): Promise<WlPriceListJson | null> {
        const response = await this.httpInstance().get("/priceList");
        if (response.data === null) {
            return null;
        }
        return response.data as WlPriceListJson;
    }
}
